import axios from 'axios'
import { API_URL } from '../api'

const publicAxios = axios.create()

export function getLocation(callback) {
	return dispatch => {
		publicAxios.get('https://ipwho.is/')
			.then(response => {
				callback(response.data.city + ', ' + response.data.country)
			})
			.catch(error => console.log(error))
	}
}

export function getDashboardData(accountId, callback, token = null) {
	if (token) {		
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
	}

	return dispatch => {
		axios.get(API_URL + '/dashboard?id=' + accountId).then(response => {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data,
				entityType: 'dashboardData',
			})

			callback()
		})
	}
}

export const togglePreference = (user, type) => {
	return dispatch => {
		const key = type+'_toggled'

		axios.post(API_URL+'/user/togglePreference', { 
			toggled: !user[key],
			key
		}).catch(error => {
			console.log(error)
		})

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				...user,
				[key]: !user[key]
			},
			entityType: 'user',
		})
	}
}

export function getAllProjectProgress(accountId, offset) {
	return dispatch => {
		axios.get(API_URL + '/dashboard/getAllProgress?id='+accountId+'&offset='+offset).then(response => {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data,
				entityType: 'project',
				isArray: true
			})
		})
	}
}

export const dashboardQuery = (id, type, callback) => {
	return dispatch => {
		axios.post(API_URL+'/dashboard/query', { id, type })
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'dashboardQuery',
				})

				callback()
			})
	}
}

export const getTimeTrackingTotals = (projectId, callback) => {
	return dispatch => {
		axios.get(API_URL+'/dashboard/timeTrackingTotals/'+projectId)
			.then(response => {
				if(callback){
					callback(response.data)
				}
			})
			.catch(error => {
				console.log(error)
			})
	}
}